module.exports = __webpack_public_path__ + "static/media/Roboto-ThinItalic.460b4830.ttf";